import React, {useState} from 'react';
import styled from 'styled-components';
import {CONSTS}  from './_constants';

const Overlay = styled.div`
    position: fixed;
    z-index:1000;
    left:0;
    right:0;
    bottom:0;
    top:0;
    width: 100%;
    height: 100%;
    background:rgba(0, 0, 0, .3);
    opacity: 0;
    transition: opacity .2s;
    pointer-events: none;
    &.active{
        opacity: 1;
        pointer-events: all;
    }
`;


const Modal = ({className, children, active, onToggle}) => {
    return (
        <>
            <Overlay className={active && "active"} onClick={onToggle}/>
            <div className={`${className} ${active && "active"}`}>
                <div className="_overlay"></div>
                <div className="_header">
                    <div className="_title">New report item</div>
                    <div className="_close" onClick={onToggle}>x</div>
                </div>
                <div className="_body">
                    {children}
                </div>
            </div>
            
        </>
    )
}

const StyledModal = styled(Modal)`
    position: fixed;
    left: 50%;
    top:50%;
    transform:translate(-50%, 50%) scale(0);
    width: 400px;
    opacity:0;
    background: #fff;
    border-radius: ${CONSTS.border.radius2};
    z-index:1001;
    transition: opacity .2s, transform .3s;
    transition-timing-function:ease-out;
    overflow: hidden;
    pointer-events: none;
    box-shadow: 0px 2px 11px rgba(0, 0, 0, .21);
    > ._header{
        height: 51px;
        background-color: ${CONSTS.colors.primary};
        color: #fff;
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        > ._title{
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: left;
            padding: 0 20px;
            font-size: 14px;
        }
        > ._close{
            flex-basis: 51px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            cursor: pointer;
            position: relative;
            color: rgba(255, 255, 255, .8);
            transition: color .2s;
            background-color: ${CONSTS.colors.primaryDark};
            text-align: center;
            &:hover{
                color: rgba(255, 255, 255, 1);
            }
        }
    }
    
    > ._body{
        padding: 15px 20px;
    }
    &.active{
        opacity: 1;
        transform:translate(-50%, -50%) scale(1);
        pointer-events: all;
    }
`;


export default StyledModal;